'use strict';

var _ = require('lodash');
function UserManagementToolbarBookmarksService(UserManagementConstants, featureToggleService) {
  var BOOKMARKS = [{
    label: 'Manage Users',
    value: UserManagementConstants.SCREEN_VALUE.MANAGE_USERS,
    ifFeatureEnabled: 'REVENUE_OPTIMIZER,DYNAMIC_AVAILABILITY,FARES_OPTIMIZER'
  }, {
    label: 'Role Management',
    value: UserManagementConstants.SCREEN_VALUE.ROLE_MANAGEMENT,
    ifFeatureEnabled: 'REVENUE_OPTIMIZER,DYNAMIC_AVAILABILITY,FARES_OPTIMIZER'
  }, {
    label: 'Workflow Settings',
    value: UserManagementConstants.SCREEN_VALUE.WORKFLOW_DEFAULT_SETTINGS,
    ifFeatureEnabled: 'REVENUE_OPTIMIZER'
  }, {
    label: 'Date and Time',
    value: UserManagementConstants.SCREEN_VALUE.DATE_TIME_NUMBER_DEFAULT_FORMAT,
    ifFeatureEnabled: 'REVENUE_OPTIMIZER,DYNAMIC_AVAILABILITY,FARES_OPTIMIZER'
  }];
  function getBookmarks() {
    return _.filter(BOOKMARKS, featureToggleService.isEnabledBasedOnConfig);
  }
  return {
    getBookmarks: getBookmarks
  };
}
UserManagementToolbarBookmarksService.$inject = ['UserManagementConstants', 'FeatureToggleService'];
module.exports = UserManagementToolbarBookmarksService;